import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/pages/Login.vue'
import CourseList from '@/pages/CourseList.vue'
import ProductList from '@/pages/ProductList.vue'
import ProductDetail from '@/pages/ProductDetail.vue'
import ProductCreate from '@/pages/ProductCreate.vue'
import ProductCheckout from '@/pages/ProductCheckout.vue'
import CourseDetail from '@/pages/CourseDetail.vue'
import OrderDetail from '@/pages/OrderDetail.vue'
import Checkout from '@/pages/Checkout.vue'
import CheckoutSuccess from '@/pages/CheckoutSuccess.vue'

const routes = [
  {
    path: '/',
    redirect: '/herzbeben'
  },
  {
    path: '/herzbeben',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/herzbeben/courses',
    name: 'CourseList',
    component: CourseList,
    meta: { requiresAuth: true }
  },
  {
    path: '/herzbeben/products',
    name: 'ProductList',
    component: ProductList,
    meta: { requiresAuth: true }
  },
  {
    path: '/herzbeben/products/new',
    name: 'ProductCreate',
    component: ProductCreate,
    meta: { requiresAuth: true }
  },
  {
    path: '/herzbeben/products/:id',
    name: 'ProductDetail',
    component: ProductDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/herzbeben/courses/:id',
    name: 'CourseDetail',
    component: CourseDetail,
    meta: { requiresAuth: true }
  },
  // Course-scoped order view
  {
    path: '/herzbeben/courses/:id/order/:orderId',
    name: 'CourseOrderDetail',
    component: OrderDetail,
    meta: { requiresAuth: true }
  },
  // Product-scoped order view
  {
    path: '/herzbeben/products/:id/order/:orderId',
    name: 'ProductOrderDetail',
    component: OrderDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/checkout/:courseId',
    name: 'Checkout',
    component: Checkout,
    meta: { requiresAuth: false }
  },
  {
    path: '/product/:id/checkout',
    name: 'ProductCheckout',
    component: ProductCheckout,
    meta: { requiresAuth: false }
  },
  {
    path: '/checkout/success',
    name: 'CheckoutSuccess',
    component: CheckoutSuccess,
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('auth_token')
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/herzbeben')
  } else if (to.path === '/herzbeben' && isAuthenticated) {
    next('/herzbeben/courses')
  } else {
    next()
  }
})

export default router 